export default function CustomeDashboard() {
    return <p>Test av CustomerDashboard</p>;
}
